import { animate, style, transition, trigger } from '@angular/animations';

export function fadeOutLeftAnimation(duration: number) {
  return trigger('fadeOutLeft', [
    transition(':leave', [
      style({
        transform: 'translateX(0)',
        opacity: 1
      }),
      animate(`${duration}ms cubic-bezier(0.35, 0, 0.25, 1)`, style({
        transform: 'translateX(-20px)',
        opacity: 0
      }))
    ])
  ]);
}

export const fadeOutLeft400ms = fadeOutLeftAnimation(400);
